import { createStyles, makeStyles } from '@material-ui/core'

export default makeStyles((theme) =>
  createStyles({
    labelTextDisabled: { color: theme.palette.text.disabled },
  })
)
